import { render, staticRenderFns } from "./GuestLogos.vue?vue&type=template&id=2ece072d&"
import script from "./GuestLogos.vue?vue&type=script&lang=ts&"
export * from "./GuestLogos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports